// extracted by mini-css-extract-plugin
export var cardHeader = "_fe-0";
export var reorderHandle = "_fe-3";
export var titleArea = "_fe-1";
export var titleAreaWithHandle = "_fe-2";